import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './pages/Navbar'; 
import Home from './components/Home';
import About from './components/About';
import Contact from './components/Contact';
import UsefulInformation from './components/UsefulInformation';
import Services from './components/Services';
import Footer from './components/Footer';





const App = () => {
  return (

    <Router>
  
    
      <Navbar />

      <Routes>
       
        <Route path="/home" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/useful-information" element={<UsefulInformation />} />
        <Route path="/services" element={<Services />} />
        <Route path="/contact" element={<Contact />} />
        
 
        <Route path="/" element={<Home />} />  {/* Ana sayfa */}
      </Routes>



      
      <Footer />
    </Router>
  
  );
};

export default (App);
